var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#F66524",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.9999C14.447 12.9999 14.0001 13.448 14.0001 13.9999V18C14.0001 18.551 13.552 18.9999 12.9999 18.9999H9.99994V3.99994C9.99994 3.14594 9.45593 2.38293 8.638 2.09894L8.34192 1.99988H12.9999C13.552 1.99988 14.0001 2.44885 14.0001 3V6C14.0001 6.55188 14.447 6.99994 15 6.99994C15.553 6.99994 15.9999 6.55188 15.9999 6V3C15.9999 1.34601 14.6539 0 12.9999 0H2.25C2.21191 0 2.18005 0.0170288 2.14307 0.0219726C2.09491 0.0179443 2.04895 0 2.00006 0C0.897034 0 0 0.896851 0 1.99988V19.9999C0 20.8539 0.544006 21.6169 1.36194 21.9009L7.38007 23.907C7.58404 23.97 7.78693 24 8.00006 24C9.10309 24 9.99994 23.103 9.99994 21.9999V21H12.9999C14.6539 21 15.9999 19.654 15.9999 18V13.9999C15.9999 13.448 15.553 12.9999 15 12.9999Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.707 9.29272L19.7069 5.29278C19.4211 5.00677 18.991 4.92071 18.6171 5.07562C18.2441 5.23071 18 5.59564 18 5.99975V8.99975H14.0001C13.448 8.99975 12.9999 9.44763 12.9999 9.99969C12.9999 10.5518 13.448 10.9996 14.0001 10.9996H18V13.9996C18 14.4037 18.2441 14.7687 18.6171 14.9238C18.991 15.0787 19.4211 14.9926 19.7069 14.7068L23.707 10.7067C24.098 10.3157 24.098 9.68365 23.707 9.29272Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/IconLogout.70ae38401bd202cb5a6fb9aff3b09536.svg";
export { ForwardRef as ReactComponent };